import PropTypes from 'prop-types';
import React from 'react';
import geolib from 'geolib';
import { Map, Marker } from 'components/maps';
import { getCenterForMapBasedOnCountryCode } from 'utils/localization/utils';

const getCenter = (markers) => {
  if (!markers || markers.length === 0) return null;

  const points = markers.map((m) => ({
    latitude: m.coords.lat,
    longitude: m.coords.lng,
  }));

  const center = geolib.getCenter(points);
  if (center) {
    return {
      lat: parseFloat(center.latitude),
      lng: parseFloat(center.longitude),
    };
  }
  return null;
};

const CargomaticMap = ({
  center = getCenterForMapBasedOnCountryCode(),
  markers = [],
  height = 350,
  defaultZoom = 10,
  onMapReady,
}) => {
  const computedCenter =
    markers && markers.length > 0 ? getCenter(markers) : center;

  return (
    <Map
      height={height}
      defaultZoom={defaultZoom}
      defaultCenter={computedCenter}
      center={computedCenter}
      fitBoundsTo={markers.map((m) => m.coords)}
      onMapReady={onMapReady}
    >
      {markers.map((marker, i) => (
        <Marker
          key={i}
          title={marker.title}
          position={marker.coords}
          icon={marker.icon}
        />
      ))}
    </Map>
  );
};

CargomaticMap.propTypes = {
  center: PropTypes.object,
  markers: PropTypes.array,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  defaultZoom: PropTypes.number,
  onMapReady: PropTypes.func,
};

export default CargomaticMap;
